import {Component, OnDestroy, OnInit} from '@angular/core';
import {MatButtonModule} from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import {MatGridListModule} from '@angular/material/grid-list';
import {MatSelectModule} from '@angular/material/select';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import { FormBuilder, FormGroup, Validators, FormsModule, ReactiveFormsModule} from '@angular/forms';
import {merge, Subscription} from 'rxjs';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { trigger, state, style, transition, animate } from '@angular/animations';

import { CONTACT } from '../data';
import { ScreensizeStateService } from '../../../../state-management/services/screensize-state.service';
import { CoordinatesSystem, ScreenWidthBreakpoints } from '../../../../state-management/model/enums/screen-size.enums';


@Component({
    selector: 'app-userinfo-contact',
    standalone: true,
    imports: [
      MatButtonModule, 
      MatIconModule, 
      MatGridListModule, 
      MatFormFieldModule,
      MatInputModule, 
      MatSelectModule, 
      FormsModule, 
      ReactiveFormsModule, 
      MatCheckboxModule, 
    ],
    templateUrl: './userinfo-contact.component.html',
    styleUrl: './userinfo-contact.component.scss',
    animations: [
        trigger('dialogAnimation', [
            state('void', style({ opacity: 0, transform: 'translateY(100%)' })),
            state('*', style({ opacity: 1, transform: 'translateY(0)' })),
            transition('void => *', [
                animate('0.5s ease-out')
            ]),
            transition('* => void', [
                animate('0.5s ease-in', style({ opacity: 0, transform: 'translateY(100%)' }))
            ])
        ])
    ]
})
export class UserinfoContactComponent implements OnInit, OnDestroy {
  private dialogSubscription: Subscription = new Subscription();
  public CONTACT = CONTACT;

  contactForm: FormGroup;
  errorMessage: string = '';
  showsubmissionMessage: boolean = false;
  public isSmallScreen$ = this.screenSize.isScreenSize(CoordinatesSystem.ScreenWidth, ScreenWidthBreakpoints.XSmall);

  constructor(
    private fb: FormBuilder, private screenSize: ScreensizeStateService) {
    
    this.contactForm = this.fb.group({
      email: ['', [Validators.required, Validators.email]],
      phone: ['', [Validators.pattern('^[0-9]*$')]],
      name: ['', [Validators.required]],
      message: ['', [Validators.required]],
      termsAccepted: [false, Validators.requiredTrue],
      
    });

    const emailControl = this.contactForm.get('email');

    if (emailControl) {
      this.dialogSubscription = merge(emailControl.statusChanges, emailControl.valueChanges)
        .pipe(takeUntilDestroyed())
        .subscribe(() => this.updateErrorMessage(emailControl));
    }
  }

  ngOnInit() { }

  ngOnDestroy() {
    if(this.dialogSubscription) this.dialogSubscription.unsubscribe();
  }

  get email() {
    return this.contactForm.get('email')!;
  }
  get phone() {
    return this.contactForm.get('phone')!;
  }
  get name() {
    return this.contactForm.get('name')!;
  }
  get message() {
    return this.contactForm.get('message')!;
  }
  get termsAccepted() {
    return this.contactForm.get('termsAccepted')!;
  }

  updateErrorMessage(control: any) {
    if (control.hasError('required')) {
      this.errorMessage = 'Bitte füllen Sie das Feld aus';
    } else if (control.hasError('email')) {
      this.errorMessage = 'Bitte geben Sie eine gültige E-mail-Adresse ein';
    } else {
      this.errorMessage = '';
    }
  }

  onSubmit() {
    if (this.contactForm.valid) {
      console.log('Form Submitted', this.contactForm.value);
      //this.submissionMessage = 'Vielen Dank für Ihre Nachricht. Wir melden uns in Kürze bei Ihnen!';
      this.showsubmissionMessage = true
    } else {
      this.contactForm.markAllAsTouched();
      if (this.email.invalid) {
        this.updateErrorMessage(this.email);
      }
    }
  }
  
  sendEmail(): void {
    window.location.href = `mailto:${CONTACT.email}`;
  }

  sendWhatsApp(): void {
    window.location.href = `https://wa.me/${CONTACT.mobile}`;
  }

  callMobile(): void {
    window.location.href = `tel:${CONTACT.mobile}`;
  }

}
